import { apiPost } from './api';
/**
 * URL de téléchargement de l'application Framerie provenant des variables d'environnement Vite
 * Doit être définie dans `.env` en tant que `VITE_FRAMERIE_DOWNLOAD_URL`.
 * Exemple : VITE_FRAMERIE_DOWNLOAD_URL="https://cdn.example.com/Framerie_1.0.5_x64-setup.exe"
 */
const FRAMERIE_DOWNLOAD_URL: string = import.meta.env.VITE_FRAMERIE_DOWNLOAD_URL;
const APP_VERSION: string | undefined = import.meta.env.VITE_APP_VERSION;

if (!FRAMERIE_DOWNLOAD_URL) {
  throw new Error('Missing VITE_FRAMERIE_DOWNLOAD_URL (.env not configured)');
}

/**
 * Lance le téléchargement de l'application Framerie
 * Redirige l'utilisateur vers l'URL de téléchargement
 */
export const downloadFramerie = (): void => {
  if (!FRAMERIE_DOWNLOAD_URL) return;
  // Fire-and-forget analytics increment; do not block navigation
  const v = APP_VERSION;
  apiPost('/v1/analytics/downloads/increment', v ? { version: v } : undefined);
  window.location.href = FRAMERIE_DOWNLOAD_URL;
};

/**
 * Lance le téléchargement de Framerie dans un nouvel onglet
 * Utile si on veut garder l'utilisateur sur la landing page
 */
export const downloadFramerieNewTab = (): void => {
  if (!FRAMERIE_DOWNLOAD_URL) return;
  const v = APP_VERSION;
  apiPost('/v1/analytics/downloads/increment', v ? { version: v } : undefined);
  window.open(FRAMERIE_DOWNLOAD_URL, '_blank');
};
